'use strict';

var index = require('../../../../_virtual/index.js_commonjs-module8.js');
require('./cjs/react-is.production.min.js');
require('./cjs/react-is.development.js');
var reactIs_production_min = require('../../../../_virtual/react-is.production.min.js_commonjs-exports4.js');
var reactIs_development = require('../../../../_virtual/react-is.development.js_commonjs-exports4.js');

if (process.env.NODE_ENV === 'production') {
  index.reactIs.exports = reactIs_production_min.__exports;
} else {
  index.reactIs.exports = reactIs_development.__exports;
}
